import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function Modal({
  isOpen,
  onClose,
  children,
  title,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-188">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-189" />

      {/* Modal */}
      <div className={`relative bg-navy-800 border border-slate-700 rounded-lg shadow-2xl w-full ${sizeClasses[size]} max-h-[90vh] overflow-y-auto`} data-id="element-190">
        {/* Header */}
        {title && <div className="flex items-center justify-between p-6 border-b border-slate-700" data-id="element-191">
            <h2 className="text-xl font-semibold text-white" data-id="element-192">{title}</h2>
            <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 rounded" aria-label="Close" data-id="element-193">
              <X className="h-5 w-5" data-id="element-194" />
            </button>
          </div>}

        {/* Content */}
        <div className="p-6" data-id="element-195">{children}</div>
      </div>
    </div>;
}